import { z } from 'zod';

const schema = z.object({
  VITE_API_BASE_URL: z.string().min(1).default('https://api.blino.ir/api/'),
  VITE_NESHAN_MAP_KEY: z.string().default(''),
  VITE_NESHAN_SERVICE_KEY: z.string().default(''),
  VITE_SUPPORT_PHONE: z.string().default('03435153'),
  /** Google Apps Script web-app that stores complaints / career requests in a sheet. */
  VITE_SUPPORT_SCRIPT_URL: z
    .string()
    .default(
      'https://script.google.com/macros/s/AKfycbzFF1wRHv9iJpkvPAmryt-R2mv-5bHN7cnBTqwMRSmkdiIXEGhSS1schvlAiQY5e-xF/exec',
    ),
});

/** Validated, typed environment. Fails fast at boot if something is malformed. */
export const env = (() => {
  const parsed = schema.safeParse(import.meta.env);
  if (!parsed.success) {
    throw new Error(`Invalid environment: ${parsed.error.message}`);
  }
  return {
    apiBaseUrl: parsed.data.VITE_API_BASE_URL.replace(/\/?$/, '/'),
    neshanMapKey: parsed.data.VITE_NESHAN_MAP_KEY,
    neshanServiceKey: parsed.data.VITE_NESHAN_SERVICE_KEY,
    supportPhone: parsed.data.VITE_SUPPORT_PHONE,
    supportScriptUrl: parsed.data.VITE_SUPPORT_SCRIPT_URL,
  } as const;
})();
